import React from 'react';
import { LinkProps } from '@mui/material';
import ZeusLink from './ZeusLink';

interface ZeusUserLinkProps extends Omit<LinkProps, 'href' | 'children'> {
  user: {
    id: number;
    fullName: string;
  };
}

export default function ZeusUserLink({ user, ...linkProps }: ZeusUserLinkProps) {
  return (
    <ZeusLink path={`/users/${user.id}`} {...linkProps}>
      {user.fullName}
    </ZeusLink>
  );
}
